import utils from "@bigcommerce/stencil-utils";

export default function () {
  let check_carouselBelowProduct = true,
    check_carouselBannerReviewCustomer = true,
    check_CarouselBlockPost = true;
  function build() {
    let countDownItem = document.querySelector(".time-count-down");
    createCountDownPromotion(countDownItem);
    loadProductID();
    lazyloadBackground();
    window.addEventListener("scroll", (e) => {
      const $target = $(e.currentTarget);
      const tScroll = $target.scrollTop();
      createCarouselBannerBelowProducts(tScroll);
      createCarouselBannerReviewCustomer(tScroll);
      createCarouselBlockPost(tScroll);
      lazyloadBackground(tScroll);
    });
  }
  function lazyloadBackground(tScroll) {
    let listBg = document.querySelectorAll("[data-bg]");
    if (listBg) {
      listBg.forEach((elem) => {
        const $carouselLazyLoadBGTop = elem.offsetTop - screen.height - 50;
        if (tScroll > $carouselLazyLoadBGTop) {
          if (elem.hasAttribute("data-bg")) {
            let style = elem.getAttribute("data-bg");
            elem.setAttribute("style", style);
            elem.removeAttribute("data-bg");
          }
        }
      });
    }
  }
  function createCarouselBannerBelowProducts(tScroll) {
    let selector = "#carouselBannerItem .carouselBannerCarousel";
    const $carouselBelowProduct = $(selector);
    if ($carouselBelowProduct.length) {
      const $carouselBelowProductTop =
        $carouselBelowProduct.offset().top - screen.height - 50;
      if (tScroll > $carouselBelowProductTop && check_carouselBelowProduct) {
        check_carouselBelowProduct = false;
        $(selector).slick({
          dots: false,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          accessibility: true,
          mobileFirst: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2000,
          speed: 300,
          fade: true,
          cssEase: "linear",
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 6000,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 6000,
                dots: true,
                arrows: false,
              },
            },
            {
              breakpoint: 551,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 6000,
                dots: true,
                arrows: false,
              },
            },
            {
              breakpoint: 10,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 6000,
                dots: true,
                arrows: false,
              },
            },
          ],
        });
      }
    }
  }
  
  function loadProductID() {
    const $element = $(".product-with-banner"),
      $options = {
        template: "halothemes/home/halo-product-with-banner",
      };

    $element.each((index, response) => {
      const $prodId = $element.eq(index).data("product-id");

      if ($prodId != undefined) {
        utils.api.product.getById($prodId, $options, (err, response) => {
          if (err) {
            return false;
          }

          $element.eq(index).html(response);
        });
      }
    });
  }
  function createCountDownPromotion(countDownItem) {
    if (countDownItem) {
      let countDownDate = new Date(
        countDownItem.getAttribute("data-deadline")
      ).getTime();
      let x = setInterval(function () {
        let now = new Date().getTime();
        let distance = countDownDate - now;
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        if (days < 10) {
          days = "0" + days.toString();
        }
        if (hours < 10) {
          hours = "0" + hours.toString();
        }
        if (minutes < 10) {
          minutes = "0" + minutes.toString();
        }
        if (seconds < 10) {
          seconds = "0" + seconds.toString();
        }
        countDownItem.innerHTML =
          days + "D : " + hours + " : " + minutes + " : " + seconds;
        if (distance < 0) {
          clearInterval(x);
          countDownItem.innerHTML = "~~EXPIRED~~";
        }
      }, 1000);
    }
  }
  function createCarouselBannerReviewCustomer(tScroll) {
    let selector = ".customerReviews__carousel";
    const $carouselCarouselBannerReviewCustomer = $(selector);
    if ($carouselCarouselBannerReviewCustomer.length) {
      const $carouselCarouselBannerReviewCustomerTop =
        $carouselCarouselBannerReviewCustomer.offset().top - screen.height - 50;
      if (
        tScroll > $carouselCarouselBannerReviewCustomerTop &&
        check_carouselBannerReviewCustomer
      ) {
        check_carouselBannerReviewCustomer = false;
        $(selector).slick({
          dots: false,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: false,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
              },
            },
            {
              breakpoint: 551,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
              },
            },
            {
              breakpoint: 10,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
              },
            },
          ],
        });
      }
    }
  }
  function createCarouselBlockPost(tScroll) {
    let selector = "#blockpost";
    const $carouselCarouselBlockPost = $(selector);
    if ($carouselCarouselBlockPost.length) {
      const $carouselCarouselBlockPostTop =
        $carouselCarouselBlockPost.offset().top - screen.height;
      if (tScroll > $carouselCarouselBlockPostTop && check_CarouselBlockPost) {
        check_CarouselBlockPost = false;
        $(selector).slick({
          dots: false,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: true,
          autoplay: false,
          autoplaySpeed: 2000,
          fade: false,
          centerPadding: "0px",
          // cssEase: 'linear',
          centerMode: true,
        });
      }
    }
  }

  build();
}
